<nav role="navigation">
  @if (pageNumber) {
    <ul sd-list-inline>
      @if (pageNumber.length > 1) {
        <li class="is-prev">
          <a sd-button
            type="button"
            rel="prev"
            class="is-pagination {{activePage === firstPage ? 'is-disabled' : ''}}"
            [attr.href]="activePage > 2 ? linkUrl + (activePage - 1) : linkUrlNoParams"
            [brand]="brand"
            icon="icon-arrow-left"
            [isIcon]="true"
            (click)="goToPreviousPage($event)"
            [attr.aria-disabled]="activePage === firstPage"
          >
            <span class="is-visually-hidden">{{ 'navigation.pagination.actions.prev' | translate: {'context': context} }}</span>
          </a>
        </li>
      }
      @if (activePage > 3) {
        <li>
          <a sd-button
            type="button"
            [brand]="brand"
            [attr.href]="pageNumber[0]?.index > 1 ? linkUrl + pageNumber[0]?.index : linkUrlNoParams"
            [isPagination]="true"
            [isSecondary]="true"
            (click)="clickGoToPage($event, firstPage)"
          >
            1
            <span class="is-visually-hidden"> - {{ 'navigation.pagination.a11y.page' | translate: {'context': context, 'currentPage': 1, 'totalPage': lastPage} }}</span>
          </a>
        </li>
        @if (pages > _maxDisplayedPage && activePage > 2 + nbPagesBeforeAfterCurrent) {
          <li>
            ...
          </li>
        }
      }
      @for (page of pageNumber | slice: (spliceStartValue || 0) : (spliceEndValue || pageNumber.length); track page.index) {
        <li>
          <a sd-button
            type="button"
            class="{{activePage === page.index ? 'is-active' : ''}}"
            [brand]="brand"
            [attr.href]="page.index > 1 ? linkUrl + page.index : linkUrlNoParams"
            [isPagination]="true"
            [isSecondary]="true"
            (click)="clickGoToPage($event, page.index)"
          >
            {{ page.index }}
            <span class="is-visually-hidden"> - {{ 'navigation.pagination.a11y.page' | translate: {'context': context, 'currentPage': page.index, 'totalPage': lastPage} }}</span>
          </a>
        </li>
      }
      @if (activePage < 3 && showLevels && pages > _maxDisplayedPage) {
        <li class="is-body-s is-bold is-color-theme-regular">
          ...
        </li>
      }
      @if (showLevels) {
        @for (level of arrayLevels; track level) {
          <li>
            @if (($index + 1) * 10 > activePage && (activePage + 2) < ($index + 1) * 10 && ($index + 1) * 10 < lastPage) {
              <a sd-button
                type="button"
                class="{{activePage === ($index + 1) * 10 ? 'is-active' : ''}}"
                [brand]="brand"
                [attr.href]="($index + 1) * 10 > 1 ? linkUrl + ($index + 1) * 10 : linkUrlNoParams"
                [isPagination]="true"
                [isSecondary]="true"
                (click)="clickGoToPage($event, ($index + 1) * 10)"
              >
                {{ ($index + 1) * 10 }}
                <span class="is-visually-hidden"> - {{ 'navigation.pagination.a11y.page' | translate: {'context': context, 'currentPage': ($index + 1) * 10, 'totalPage': lastPage} }}</span>
              </a>
            }
          </li>
        }
      }
      @if (lastLevel && lastLevel > 100 && activePage < 98 && !isMobile$) {
        <li>
          <a sd-button
            type="button"
            class="{{activePage === 100 ? 'is-active' : ''}}"
            [brand]="brand"
            [attr.href]="100 > 1 ? linkUrl + 100 : linkUrlNoParams"
            [isPagination]="true"
            [isSecondary]="true"
            (click)="clickGoToPage($event, 100)"
          >
            100
            <span class="is-visually-hidden"> - {{ 'navigation.pagination.a11y.page' | translate: {'context': context, 'currentPage': 100, 'totalPage': lastPage} }}</span>
          </a>
        </li>
      }
      @if (showLastLevel && !isMobile$) {
        <li>
          <a sd-button
            type="button"
            class="{{activePage === lastLevel ? 'is-active' : ''}}"
            [brand]="brand"
            [attr.href]="lastLevel > 1 ? linkUrl + lastLevel : linkUrlNoParams"
            [isPagination]="true"
            [isSecondary]="true"
            (click)="clickGoToPage($event, lastLevel)"
          >
            {{ lastLevel }}
            <span class="is-visually-hidden"> - {{ 'navigation.pagination.a11y.page' | translate: {'context': context, 'currentPage': lastLevel, 'totalPage': lastPage} }}</span>
          </a>
        </li>
      }
      @if (spliceEndValue !== lastPage - 1
        && (showLastLevel && lastLevel !== lastPage - 1 || !showLastLevel)
        && (showLevels && arrayLevels?.length * 10 !== lastPage - 1 || !showLevels)) {
        <li class="is-body-s is-bold is-color-theme-regular">
          @if (spliceEndValue !== undefined) {
            ...
          }
        </li>
      }
      @if (pages > _maxDisplayedPage) {
        <li>
          <a sd-button
            type="button"
            class="{{activePage === lastPage ? 'is-active' : ''}}"
            [brand]="brand"
            [attr.href]="lastPage > 1 ? linkUrl + lastPage : linkUrlNoParams"
            [isPagination]="true"
            [isSecondary]="true"
            (click)="clickGoToPage($event, lastPage)"
          >
            {{ lastPage }}
            <span class="is-visually-hidden"> - {{ 'navigation.pagination.a11y.page' | translate: {'context': context, 'currentPage': lastPage, 'totalPage': lastPage} }}</span>
          </a>
        </li>
      }
      @if (pageNumber.length > 1) {
        <li class="is-next">
          <a sd-button
            type="button"
            rel="next"
            class="is-pagination {{activePage === lastPage ? 'is-disabled' : ''}}"
            [brand]="brand"
            [attr.href]="activePage < lastPage ? linkUrl + (activePage + 1) : linkUrlNoParams"
            icon="icon-arrow-right"
            [isIcon]="true"
            (click)="goToNextPage($event)"
            [attr.aria-disabled]="activePage === lastPage"
          >
            <span class="is-visually-hidden">{{ 'navigation.pagination.actions.next' | translate: {'context': context} }}</span>
          </a>
        </li>
      }
    </ul>
  }
  @if (pageNumber && pages > 10 && arrayLastLevels?.length > 0) {
    <div sdIsCollapsible
      class="c__levels"
      id="levels"
      [cleanCode]="false"
      [collapsiblePanel]="hide"
      (isOpenChange)="isOpen = !isOpen"
      [action]="action"
    >
      <a #action class="c__levels-action is-block is-bold" [attr.aria-controls]="'lastLevels'">
        {{ (!isOpen ? 'navigation.pagination.actions.seeMore':'navigation.pagination.actions.seeLess') | translate }}
      </a>
      <div #hide>
        <ul sd-list-inline class="c__last-levels" id="lastLevels">
          @for (level of arrayLastLevels; track level) {
            <li>
              <a sd-button
                type="button"
                class="{{activePage === level ? 'is-active' : ''}}"
                [brand]="brand"
                [attr.href]="level > 1 ? linkUrl + level : linkUrlNoParams"
                [isPagination]="true"
                [isSecondary]="true"
                (click)="clickGoToPage($event, level)"
              >
                {{ level }}
                <span class="is-visually-hidden"> - {{ 'navigation.pagination.a11y.page' | translate: {'context': context, 'currentPage': level, 'totalPage': lastPage} }}</span>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  }
</nav>
